const prefix = 'products';

export const FIND_PRODUCT = `${prefix}/FIND_PRODUCT`;
